import { Component, Vue, Watch } from 'vue-property-decorator';
//@ts-ignore
import { DateTime } from "luxon";
//@ts-ignore
import Calendar from 'v-calendar/lib/components/calendar.umd'
//@ts-ignore
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import * as service from "@/methods/service";
import * as availableTime from "@/apis/availableTime";
import store from "@/store";

@Component({
    components: {
        Calendar,
        DatePicker
    },
})
export default class SelectYourDeliveryComponent extends Vue {

    public isMediaLessThanMD: boolean = false;

    error = '';

    start: any = null
    tempStart: any = null
    end: any = null

    yearEnd = '';
    yearStart = '';

    utc = ['UTC']

    monthStart: any = '';
    monthEnd: any = '';

    endMonth: any = '';

    allDaysEnd: any[] = [];
    allDaysStart: any[] = [];

    downloadedDates: any = [];

    objDisabledStart: any = {};
    objDisabledEnd: any = {};

    async dayClick(day: any) {
        if (this.tempStart && day.month === this.tempStart.month && day.day !== this.tempStart.day) {
            const index = this.objDisabledStart.disabledDates.indexOf(this.tempStart.day)
            if (index != '-1') {
                this.objDisabledStart.disabledDates.splice(index, 1);
                this.tempStart = day
            }
        } else {
            if (this.tempStart && day.month !== this.tempStart.month) {
                this.downloadedDates.find((obj: any) => obj.month == this.tempStart.month).disabledDates.pop()
                this.tempStart = day
            } else {
                this.tempStart = day
            }
        }
        let end = new Date(this.start)
        end.setDate(end.getDate() + 7)
        await this.pageChangeEnd({ year: +end.getFullYear(), month: +end.getMonth() + 1 })
        this.end = end
        this.endMonth = this.end.getMonth() + 1
        //@ts-ignore
        this.$refs.start.hidePopover()
        sessionStorage.setItem('endDate', this.end.getTime());
        sessionStorage.setItem('startDate', this.start.getTime());
        // if(this.objDisabledEnd.month && this.endMonth != this.objDisabledEnd.endMonth){
        //     this.checkObjDisabledEnd()
        // }
    }

    openStartCalendar() {
        //@ts-ignore
        this.$refs.start.showPopover()
        //@ts-ignore
        this.$refs.end.hidePopover()
    }

    openEndCalendar() {
        //@ts-ignore
        this.$refs.end.showPopover()
        //@ts-ignore
        this.$refs.start.hidePopover()

    }

    async mounted() {
        if (sessionStorage.getItem('endDate') && sessionStorage.getItem('startDate')) {
            // @ts-ignore
            const endDate = new Date(+sessionStorage.getItem('endDate'))
            // @ts-ignore
            const startDate = new Date(+sessionStorage.getItem('startDate'))
            await this.pageChangeEnd({ year: +endDate.getFullYear(), month: +endDate.getMonth() + 1 })
            await this.pageChange({ year: +startDate.getFullYear(), month: +startDate.getMonth() + 1 })
            this.end = endDate
            this.start = startDate
        }
    }

    dayClickEnd(day: any) {
        this.endMonth = day.month
        //@ts-ignore
        this.$refs.end.hidePopover()
        sessionStorage.setItem('endDate', this.end.getTime());
    }

    async pageChangeEnd(page: any) {
        let firstDay = DateTime.utc(page.year, page.month, 1, 0, 0, 1);
        firstDay = firstDay.toMillis()
        let endDay = (new Date(page.year, page.month, 0)).getDate();
        endDay = DateTime.utc(page.year, page.month, endDay, 0, 0, 0);
        //@ts-ignore
        endDay = endDay.toMillis()

        this.allDaysEnd = this.getDaysInMonth(page.month, page.year)
        this.yearEnd = page.year;
        if (page.month < 10) {
            this.monthEnd = this.twoDigits(page.month)
        } else {
            this.monthEnd = page.month;
        }
        const mounthNow = DateTime.utc().month
        const element = document.getElementsByClassName("is-left")
        if (element.length !== 0 && mounthNow == this.monthEnd || this.monthEnd == this.monthStart) {
            setTimeout(function () {
                // @ts-ignore
                element[0].style.pointerEvents = 'none'
                // @ts-ignore
                element[0].style.opacity = '0'
            }, 0)
        } else {
            if (element.length !== 0) {
                setTimeout(function () {
                    // @ts-ignore
                    element[0].style.pointerEvents = 'auto'
                    // @ts-ignore
                    element[0].style.opacity = '100'
                }, 0)
            }
        }
        this.$store.commit('setOverlay', true)
        if (this.downloadedDates.find((dates: any) => dates.month === this.monthEnd && dates.year === this.yearEnd)) {
            this.checkObjDisabledEnd()

            // if(!!this.end && this.endMonth ==this.end.getMonth() && this.objDisabled.disabledDates.includes(this.end.getDate())){
            // 	this.end = null
            // }
            this.$store.commit('setOverlay', false)
            return
        }
        try {
            await this.retrieveDates(firstDay, endDay, this.allDaysEnd, this.monthEnd, this.yearEnd);
            this.checkObjDisabledEnd()
            this.$store.commit('setOverlay', false)
        } catch (error) {
            this.$store.commit('setOverlay', false)
        }

    }

    checkObjDisabledEnd() {
        this.objDisabledEnd = this.downloadedDates.find((dates: any) => dates.month === this.monthEnd && dates.year === this.yearEnd)
        if (this.start) {
            const mounth = this.start.getMonth()
            const year = this.start.getFullYear()
            if (mounth + 1 === +this.monthEnd && year === +this.yearEnd) {
                const dayStart = this.start.getDate()
                if (!this.objDisabledEnd.disabledDates.includes(dayStart)) {
                    this.objDisabledEnd.disabledDates.push(dayStart)
                }
            }
        }
    }

    checkObjDisabledStart() {
        this.objDisabledStart = this.downloadedDates.find((dates: any) => dates.month === this.monthStart && dates.year === this.yearStart)
        if (this.start) {
            const mounth = this.start.getMonth()
            const year = this.start.getFullYear()
            if (mounth + 1 === +this.monthStart && year === +this.yearStart) {
                const dayStart = this.start.getDate()
                if (!this.objDisabledStart.disabledDates.includes(dayStart)) {
                    this.objDisabledStart.disabledDates.push(dayStart)
                }
            }
        }
    }

    async pageChange(page: any) {

        let firstDay = DateTime.utc(page.year, page.month, 1, 0, 0, 1);
        firstDay = firstDay.toMillis()
        let endDay = (new Date(page.year, page.month, 0)).getDate();
        endDay = DateTime.utc(page.year, page.month, endDay , 0, 0, 0);
        //@ts-ignore
        endDay = endDay.toMillis()

        this.allDaysStart = this.getDaysInMonth(page.month, page.year)
        this.yearStart = page.year;
        if (page.month < 10) {
            this.monthStart = this.twoDigits(page.month)
        } else {
            this.monthStart = page.month;
        }
        const mounthNow = DateTime.utc().month
        const element = document.getElementsByClassName("is-left")
        if (element.length !== 0 && mounthNow == this.monthStart) {
            setTimeout(function () {
                // @ts-ignore
                element[0].style.pointerEvents = 'none'
                // @ts-ignore
                element[0].style.opacity = '0'
            }, 0)
        } else {
            if (element.length !== 0) {
                setTimeout(function () {
                    // @ts-ignore
                    element[0].style.pointerEvents = 'auto'
                    // @ts-ignore
                    element[0].style.opacity = '100'
                }, 0)
            }
        }
        this.$store.commit('setOverlay', true)
        if (this.downloadedDates.find((dates: any) => dates.month === this.monthStart && dates.year === this.yearStart)) {
            this.checkObjDisabledStart()
            // if(!!this.end && this.endMonth ==this.end.getMonth() && this.objDisabled.disabledDates.includes(this.end.getDate())){
            // 	this.end = null
            // }
            this.$store.commit('setOverlay', false)
            return
        }
        await this.retrieveDates(firstDay, endDay, this.allDaysStart, this.monthStart, this.yearStart);
        this.checkObjDisabledStart()
        this.$store.commit('setOverlay', false)
    }

    twoDigits(num: any) {
        return ('0' + num).slice(-2);
    }

    masks = {
        input: 'DD/MM/YYYY',
    }

    async retrieveDates(dateStart: any, dateEnd: any, allDaysStart: any, month: any, year: any) {
        const requestData = {
            securityToken: store.getters.token,
            zip: store.getters.postcode,
            serviceTypeID: 11,
            dateStartMounth: dateStart / 1000,
            dateEndMounth: dateEnd / 1000,
        };
        const response = await availableTime.availableTime(requestData)
        const { data } = response;
        if ('errNo' in data && data.errNo !== 0) {
            let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
            if (data.Errors && data.Errors.length) {
                const [firstError] = data.Errors;
                ({ errMsg } = firstError);
            }
            this.error = errMsg
            throw new Error(errMsg);
        } else {
            if (data.Availability) {
                let tmpArray: any[] = [];
                const datesFromServer = data.Availability.filter((item: any) => {
                    if (tmpArray.indexOf(item.dayID) === -1) {
                        tmpArray.push(item.dayID);
                        return true
                    }
                    return false;
                })

                const availableDates = datesFromServer.map((date: any) => {
                    
                    return DateTime.utc(
                        Number(date.dayID.substr(0, 4)), Number(date.dayID.substr(4, 2)), Number(date.dayID.substr(6, 2))
                    );
                })

                const availableDatesTime = availableDates.map((el: any) => {
                    return el = el.toMillis() + 43200000; // перевожу на канадское, так сказать)
                })
                const allDaysTime = allDaysStart.map((el: any) => {
                    return el = el.toMillis() + 43200000;
                })
                let result = allDaysTime.filter((f: any) => !availableDatesTime.includes(f));
                const disabledDates = result.map((el: any) => {
                    const dateTemp = DateTime.fromMillis(el)
                    return dateTemp.day;
                })
                const downloadedDate = {
                    month: month,
                    year: year,
                    disabledDates: disabledDates,
                    availableDates: availableDates,
                    datesFromServer: datesFromServer
                }
                this.downloadedDates.push(downloadedDate)
            } else {
                this.error = 'Not Available Dates'
                throw new Error('Not Available Dates');
            }

        }
    }

    getDaysInMonth(month: any, year: any) {
        let date = DateTime.utc(year, month, 1, 0, 0, 0);
        var days = [];
        while (date.month === month) {
            days.push(date);
            date = date.plus({ days: 1 });
        }
        return days;
    }

    onResize() {
        this.isMediaLessThanMD = window.innerWidth <= 960;
    }

    public async created() {
        window.addEventListener('resize', this.onResize)
        this.onResize();
    }

    public beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    }

    get timeZone() {
        return this.utc[0]
    }

    async bookNow() {
        let firstDateTime = new Date();
        let endDateTime = new Date();
        firstDateTime = this.start.getDate()
        const firstMonth = this.start.getMonth() + 1
        endDateTime = this.end.getDate();
        const endMonth = this.end.getMonth() + 1;
        const indexFirstDay = this.downloadedDates.find((obj: any) => obj.month == firstMonth).availableDates.findIndex((el: any) => el.day === firstDateTime)
        const indexEndDay = this.downloadedDates.find((obj: any) => obj.month == endMonth).availableDates.findIndex((el: any) => el.day === endDateTime)
        if (indexFirstDay !== -1) {
            this.$store.commit('setDeliveryDate', this.downloadedDates.find((obj: any) => obj.month == firstMonth).datesFromServer[indexFirstDay].dayID)
            this.$store.commit('setDeliveryRouteID', this.downloadedDates.find((obj: any) => obj.month == firstMonth).datesFromServer[indexFirstDay].routeID)
            this.$store.commit('setDeliveryTime', this.downloadedDates.find((obj: any) => obj.month == firstMonth).datesFromServer[indexFirstDay].startTime)
        }
        if (indexEndDay !== -1) {
            this.$store.commit('setPickUpDate', this.downloadedDates.find((obj: any) => obj.month == endMonth).datesFromServer[indexEndDay].dayID)
            this.$store.commit('setPickUpRouteID', this.downloadedDates.find((obj: any) => obj.month == endMonth).datesFromServer[indexEndDay].routeID)
            this.$store.commit('setPickUpTime', this.downloadedDates.find((obj: any) => obj.month == endMonth).datesFromServer[indexEndDay].startTime)
        }
        try {
            this.$store.commit('setOverlay', true)
            const deliveryLockID = await this.lockTime(this.$store.getters.deliveryDate, this.$store.getters.deliveryRouteID, this.$store.getters.deliveryTime)
            this.$store.commit('setDeliveryLockID', deliveryLockID)
            try {
                const pickUpLockID = await this.lockTime(this.$store.getters.pickUpDate, this.$store.getters.pickUpRouteID, this.$store.getters.pickUpTime)
                this.$store.commit('setPickUpLockID', pickUpLockID)
                this.$store.commit('setOverlay', false)
                this.$store.commit('setThirdStepComplited');
                this.$router.push({ name: 'thirdStep', params: {} })

            } catch (error) {
                this.error = error.message
                this.$store.commit('setOverlay', false)
            }
        } catch (error) {
            this.error = error.message
            this.$store.commit('setOverlay', false)
        }
    }

    async lockTime(dayID: any, routeID: any, startTime: any) {
        const requestData = {
            securityToken: store.getters.token,
            zip: store.getters.postcode,
            serviceTypeID: 11,
            dayID: dayID,
            routeID: routeID,
            startTime: startTime,
        };
        const response = await availableTime.lockTime(requestData)

        const { data } = response;
        if ('errNo' in data && data.errNo !== 0) {
            let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
            if (data.Errors && data.Errors.length) {
                const [firstError] = data.Errors;
                ({ errMsg } = firstError);
            }
            this.error = errMsg
            throw new Error(errMsg);
        } else {
            if (data.Ids) {
                return data.Ids.lockID
            } else {
                throw new Error('Can not lock time');
            }
        }
    }
}
